import { createContext } from 'react';

import type { TreeMapContextConfig } from '../types/treemap-chart.config.js';

/**
 * @internal
 */
export const TreeMapChartConfigContext = createContext<
  TreeMapContextConfig | string
>({});

/**
 * Provider for the PieChart API config that can be shared across charts
 * @public
 */
export const TreeMapConfig = TreeMapChartConfigContext.Provider;
